"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initChWebSdk = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _utils = require("./utils");

var _content = require("./content");

var _user = require("./user");

var _subscription = require("./subscription");

var _courses = require("./courses");

var _domains = require("./domains");

var _skilljar = require("./skilljar");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ChWebSdk = /*#__PURE__*/function () {
  function ChWebSdk() {
    (0, _classCallCheck2.default)(this, ChWebSdk);
  }

  (0, _createClass2.default)(ChWebSdk, [{
    key: "onReady",
    value:
    /**
     * Run a callback when the DOM is ready
     */
    function onReady(callback) {
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        callback();
      } else {
        document.addEventListener('DOMContentLoaded', callback, {
          once: true
        });
      }
    }
    /**
     * Wait until an element matching selector appears in DOM
     */

  }, {
    key: "observeElement",
    value: function observeElement(selector, callback) {
      // 1. Immediate check
      var existing = document.querySelector(selector);

      if (existing) {
        callback(existing);
        return;
      } // 2. Setup MutationObserver


      var observer = new MutationObserver(function () {
        var el = document.querySelector(selector);

        if (el) {
          observer.disconnect();
          callback(el);
        }
      });
      observer.observe(document.body || document.documentElement, {
        childList: true,
        subtree: true
      });
    }
    /**
     * Run callback when element is visible in viewport (fires once).
     */

  }, {
    key: "observeWhenVisible",
    value: function observeWhenVisible(selector, callback) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.observeElement(selector, function (el) {
        var observer = new IntersectionObserver(function (entries, obs) {
          var _iterator = _createForOfIteratorHelper(entries),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var entry = _step.value;

              if (entry.isIntersecting) {
                obs.disconnect();
                callback(entry.target);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }, options);
        observer.observe(el);
      });
    }
    /**
     * Safely bind an event to an element.
     * Returns an unsubscribe function for cleanup. If you prefer one-off handlers,
     * consider using the `options` parameter with `{ once: true }` to auto-remove.
     * Note: In many widget scenarios, elements persist for the lifetime of the page,
     * so callers might choose to ignore the returned unsubscribe.
     */

  }, {
    key: "onEvent",
    value: function onEvent(selector, event, handler, options) {
      var cleanup = null;
      this.observeElement(selector, function (el) {
        var target = el;
        target.addEventListener(event, handler, options);

        cleanup = function cleanup() {
          return target.removeEventListener(event, handler, options);
        };
      });
      return function () {
        // If the element wasn't found yet, there is nothing to remove.
        if (cleanup) cleanup();
      };
    }
    /**
     * Dynamically load an external script
     */

  }, {
    key: "loadScript",
    value: function loadScript(src, callback) {
      if (!(0, _utils.isBrowser)()) {
        return;
      }

      var existing = document.querySelector("script[src=\"".concat(src, "\"]"));

      if (existing) {
        if (callback) {
          var _dataset;

          // If the script is already present, assume loaded or attach a load listener
          if (((_dataset = existing.dataset) === null || _dataset === void 0 ? void 0 : _dataset.loaded) === 'true') {
            (0, _utils.scheduleMicrotaskWithFallback)(callback);
          } else {
            existing.addEventListener('load', function () {
              return callback();
            });
          }
        }

        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = true;

      script.onload = function () {
        script.dataset.loaded = 'true';
        callback === null || callback === void 0 ? void 0 : callback();
      };

      document.head.appendChild(script);
    }
    /**
     * Dynamically load an external stylesheet
     */

  }, {
    key: "loadStyle",
    value: function loadStyle(href) {
      if (!(0, _utils.isBrowser)()) {
        return;
      }

      var existing = document.querySelector("link[rel=\"stylesheet\"][href=\"".concat(href, "\"]"));
      if (existing) return;
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    }
    /**
     * Initialize SDK exposure for consumers (e.g., attach to window).
     * Safe to call multiple times; it will simply reassign the same instance.
     */

  }, {
    key: "init",
    value: function init() {
      if ((0, _utils.isBrowser)()) {
        ;
        globalThis.ChWebSdk = Object.freeze({
          onReady: this.onReady.bind(this),
          observeElement: this.observeElement.bind(this),
          onEvent: this.onEvent.bind(this),
          loadScript: this.loadScript.bind(this),
          loadStyle: this.loadStyle.bind(this),
          Content: _content.Content,
          User: _user.User,
          Subscription: _subscription.Subscription,
          Courses: _courses.Courses,
          Domains: _domains.Domains,
          Skilljar: _skilljar.Skilljar
        });
      }
    }
  }]);
  return ChWebSdk;
}();

var initChWebSdk = function initChWebSdk() {
  var sdk = new ChWebSdk();
  sdk.init();
  return sdk;
};

exports.initChWebSdk = initChWebSdk;
var _default = initChWebSdk;
exports.default = _default;